import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { Permission, checkPermission } from '../../../../_helpers';
import PermissionMessage from '../../Teams/PermissionMessage';
import { BsThreeDotsVertical } from 'react-icons/bs';

const ReceiverMessageThreeDots = ({
    m,
    setReplyMessage,
    user,
    userName,
    roomType,
    subChannelType,
    rId,
    subChannelId,
    userRole,
    teamData,
    currUser,
    roomData,
    handleDeleteMessage,
}) => {
    return (
        <Dropdown className="dropper">
            <Dropdown.Toggle id="dropdown-basic" className="dropdown p-1">
                <div className="dropcss-receiver">
                    <BsThreeDotsVertical color="#fff" fontSize={20} />
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu">
                <Dropdown.Item onClick={() => setReplyMessage(m, user || { name: userName })}>
                    <span>Reply</span>
                </Dropdown.Item>
                {roomType && (roomType === 'private' || roomType === 'public') && (
                    <Permission
                        role={currUser.role}
                        perform="edit:messagePermission"
                        yes={() => (
                            <PermissionMessage
                                message={m}
                                rId={rId}
                                userRole={userRole}
                                teamData={teamData}
                                currUser={currUser}
                            />
                        )}
                        no={() => {
                            let userTeamRole = teamData?.role;
                            let isTeamRoleAuthorized = checkPermission(userTeamRole, 'edit:messagePermission');
                            let userChannel = currUser.roomList
                                .filter((room) => room.room)
                                .find((room) => room.room.id === rId);
                            let userChannelRole = (userChannel || {}).role;

                            let isChannelRoleAuthorized = false;
                            if (userChannelRole) {
                                isChannelRoleAuthorized = checkPermission(userChannelRole, 'edit:messagePermission');
                            }
                            let isEditPermissionAllowed = isTeamRoleAuthorized || isChannelRoleAuthorized;

                            if (isEditPermissionAllowed) {
                                return (
                                    <PermissionMessage
                                        message={m}
                                        rId={rId}
                                        userRole={userRole}
                                        teamData={teamData}
                                        currUser={currUser}
                                    />
                                );
                            }
                            return null;
                        }}
                    />
                )}

                {subChannelType && subChannelType === 'private' && (
                    <Permission
                        role={currUser.role}
                        perform="edit:messagePermission"
                        yes={() => <PermissionMessage message={m} subChannelId={subChannelId} userRole={userRole} />}
                        no={() => {
                            let userRoomRole = roomData?.role;
                            let isRoomRoleAuthorized = checkPermission(userRoomRole, 'edit:messagePermission');
                            let userSubChannel = currUser.subChannelList
                                .filter((subChannel) => subChannel.subChannel)
                                .find((subChannel) => subChannel.subChannel.id === subChannelId);
                            let userSubChannelRole = (userSubChannel || {}).role;

                            let isSubChannelRoleAuthorized = false;
                            if (userSubChannelRole) {
                                isSubChannelRoleAuthorized = checkPermission(userRoomRole, 'edit:messagePermission');
                            }
                            let isEditPermissionAllowed = isRoomRoleAuthorized || isSubChannelRoleAuthorized;

                            if (isEditPermissionAllowed) {
                                return (
                                    <PermissionMessage message={m} subChannelId={subChannelId} userRole={userRole} />
                                );
                            }
                            return null;
                        }}
                    />
                )}

                {subChannelId ? (
                    <Permission
                        role={currUser?.role}
                        perform="delete:message"
                        yes={() => (
                            <Dropdown.Item onClick={() => handleDeleteMessage(m.id)}>
                                <span>Delete</span>
                            </Dropdown.Item>
                        )}
                        no={() => {
                            let userRoomRole = roomData?.role;
                            let isRoomRoleAuthorized = checkPermission(userRoomRole, 'delete:message');
                            let userSubChannel = currUser.subChannelList
                                .filter((subChannel) => subChannel.subChannel)
                                .find((subChannel) => subChannel.subChannel.id === rId);
                            let userSubChannelRole = (userSubChannel || {}).role;

                            let isSubChannelRoleAuthorized = false;
                            if (userSubChannelRole) {
                                isSubChannelRoleAuthorized = checkPermission(userSubChannelRole, 'delete:message');
                            }
                            let isDeleteAllowed = isRoomRoleAuthorized || isSubChannelRoleAuthorized;

                            if (isDeleteAllowed) {
                                return (
                                    <Dropdown.Item onClick={() => handleDeleteMessage(m.id)}>
                                        <span>Delete</span>
                                    </Dropdown.Item>
                                );
                            }
                            return null;
                        }}
                    />
                ) : (
                    <Permission
                        role={currUser?.role}
                        perform="delete:message"
                        yes={() => (
                            <Dropdown.Item onClick={() => handleDeleteMessage(m.id)}>
                                <span>Delete</span>
                            </Dropdown.Item>
                        )}
                        no={() => {
                            let userTeamRole = teamData?.role;
                            let isTeamRoleAuthorized = checkPermission(userTeamRole, 'delete:message');
                            let userChannel = currUser.roomList
                                .filter((room) => room.room)
                                .find((room) => room.room.id === rId);
                            let userChannelRole = (userChannel || {}).role;

                            let isChannelRoleAuthorized = false;
                            if (userChannelRole) {
                                isChannelRoleAuthorized = checkPermission(userChannelRole, 'delete:message');
                            }
                            let isDeleteAllowed = isTeamRoleAuthorized || isChannelRoleAuthorized;
                            if (isDeleteAllowed) {
                                return (
                                    <Dropdown.Item onClick={() => handleDeleteMessage(m.id)}>
                                        <span>Delete</span>
                                    </Dropdown.Item>
                                );
                            }
                            return null;
                        }}
                    />
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default ReceiverMessageThreeDots;
